/* Product card videos (WEBLCFB2C-17)
   ---------------------------------------------------------------------------
   Collection / featured-collection cards: when a product's media carousel
   contains a video, play it automatically — without a play button.

   - Desktop (hover-capable): play on card hover, pause on leave. (On desktop the
     card video sits at opacity:0 behind the image and is only revealed on hover,
     so the browser can't auto-play it and the CSS reveal doesn't start playback.)
   - Touch / no-hover: play when the video is actually visible in the viewport,
     pause when it leaves.

   The card video is rendered WITHOUT the theme `autoplay` attribute and WITHOUT a
   play button (see snippets/df-product-card-carousel.liquid). <video-media> exposes
   play()/pause() (assets/theme.js, BaseMedia); we drive playback from here so the
   desktop-hover and mobile-in-view behaviours are exactly what was requested. */
(function () {
  function vmInFigure(node) {
    var fig = node && node.closest ? node.closest('.product-card__figure') : null;
    return fig ? fig.querySelector('video-media[type="video"]') : null;
  }

  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  if (canHover) {
    // Desktop: hover the card -> play; leave -> pause.
    document.addEventListener('pointerover', function (e) {
      var vm = vmInFigure(e.target);
      if (vm && typeof vm.play === 'function') vm.play();
    });
    document.addEventListener('pointerout', function (e) {
      var fig = e.target.closest ? e.target.closest('.product-card__figure') : null;
      if (!fig) return;
      if (e.relatedTarget && fig.contains(e.relatedTarget)) return; // still inside the card
      var vm = fig.querySelector('video-media[type="video"]');
      if (vm && typeof vm.pause === 'function') vm.pause();
    });
    return;
  }

  // Touch / no-hover: play when the video slide is visible in the viewport.
  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var vm = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
        if (typeof vm.play === 'function') vm.play();
      } else if (typeof vm.pause === 'function') {
        vm.pause();
      }
    });
  }, { threshold: [0, 0.6] });

  function observeAll(root) {
    (root || document).querySelectorAll('product-card video-media[type="video"]').forEach(function (vm) {
      io.observe(vm);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observeAll(); });
  } else {
    observeAll();
  }

  // Cards added later (pagination / load-more).
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes && m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('product-card video-media[type="video"]')) io.observe(n);
        else if (n.querySelectorAll) observeAll(n);
      });
    });
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
})();
